import { getToken } from "@src/utils/LoginHelper";
import axios from "axios";

const instance = axios.create({
  baseURL: import.meta.env.VITE_REACT_SERVER_URL,
  headers: { "Content-Type": "application/json" },
});

instance.defaults.headers.common['Authorization'] = getToken();

export default instance;
